import { Card, CardBody, Tab, Tabs } from "@nextui-org/react";
import Form from "./NewProduct";
import EditForm from "./EditProduct";
import RemoveProduct from "./RemoveProduct";

const Products = () => {
    return (
        <>
            <div className="w-full flex flex-col">
                <Tabs aria-label="Options" className="border-b pb-3">
                    <Tab key="new" title="جدید">
                        <Card style={{ boxShadow: 'none' }}>
                            <CardBody>
                                <Form />
                            </CardBody>
                        </Card>
                    </Tab>
                    <Tab key="edit" title="ویرایش">
                        <Card style={{ boxShadow: 'none' }}>
                            <CardBody>
                                <EditForm edit={true} />
                            </CardBody>
                        </Card>
                    </Tab>
                    <Tab key="delete" title="حذف">
                        <Card style={{ boxShadow: 'none' }}>
                            <CardBody>
                                <RemoveProduct />
                            </CardBody>
                        </Card>
                    </Tab>
                </Tabs>
            </div>
        </>
    );
};

export default Products;